import { Attribute } from './Attribute.js';

export const ADDRESS_ATTRIBUTE_TYPE = 'AddressAttribute';
export const STREET_NAME_ATTRIBUTE_ID = 'Ulica';
export const HOUSE_NUMBER_ATTRIBUTE_ID = 'Číslo';
export const CITY_ATTRIBUTE_ID = 'Obec';
export const ZIP_CODE_ATTRIBUTE_ID = 'PSČ';

/**
 * @property {string} streetName
 * @property {string} houseNumber
 * @property {string} city
 * @property {string} zipCode
 * @property {boolean} isReadOnly
 */
export class AddressAttribute extends Attribute {
  constructor({ streetName, houseNumber, city, zipCode, isReadOnly = false }) {
    super();
    this.streetName = streetName;
    this.houseNumber = houseNumber;
    this.city = city;
    this.zipCode = zipCode;
    this.isReadOnly = isReadOnly;
    this.type = ADDRESS_ATTRIBUTE_TYPE;
  }
}
